import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { getAllProperty, getSingleProperty, updateProperty } from "./query";

const propertyApi = createApi({
  reducerPath: "propertyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: (headers) => {
      return headerWithAuthToken(headers);
    },
  }),
  endpoints: (builder) => ({
    getAllproperty: builder.query({
      providesTags: ["all_property"],
      query: getAllProperty,
    }),
    getSingleJob: builder.query({
      providesTags: ["property"],
      query: getSingleProperty,
    }),
    updateJob: builder.mutation({
      invalidatesTags: ["property"], // Changed from providesTags
      query: updateProperty,
    }),
  }),
});

export const {
  useGetAllpropertyQuery,  // Fixed naming
  useGetSinglepropertyQuery,    // Fixed naming
  useUpdatePropertyMutation,    // Fixed naming
} = propertyApi;

export const propertyApiReducer = propertyApi.reducer;
export const propertyApiReducerPath = propertyApi.reducerPath;
export const propertyApiMiddleWare = propertyApi.middleware;
